module.exports = __webpack_public_path__ + "static/img/2.2603b9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/chanpin/20201105/2.png
// module id = KM17
// module chunks = 1